import React, { useState } from "react";
import SetupLnAddressCommon from "../SetupLnAddressCommon";
import LnAddressSuccessModal from "../LnAddressSuccessModal";

function SetupLnAddressOptions({
  isOpenModal,
  setIsOpenModal,
  handleFetchLnAddress,
  isIosDevice,
}) {
  const [isAddressCreated, setIsAddressCreated] = useState(false);
  const [userName, setUserName] = useState(null);

  return (
    <>
      {!isAddressCreated && (
        <SetupLnAddressCommon
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
          directionToOpen={"up"}
          isFromBrowser={true}
          customClass="ln-address-options-modal-container"
          setIsAddressCreated={setIsAddressCreated}
          userName={userName}
          setUserName={setUserName}
          isIosDevice={isIosDevice}
        />
      )}

      {isAddressCreated && (
        <LnAddressSuccessModal
          isOpenModal={isAddressCreated}
          setIsOpenModal={setIsAddressCreated}
          userName={userName}
          handleClose={() => {
            handleFetchLnAddress();
            setIsOpenModal(false);
          }}
          customClass="ln-address-options-modal-container"
          directionToOpen="up"
          isFromBrowser={true}
        />
      )}
    </>
  );
}

export default SetupLnAddressOptions;
